// AUTO-GENERATED from apps_games_stats/v2/*.csv — do not edit by hand.
// Regenerate via apps_games_stats/generate_catalog.py if the source CSVs change.
//
// Each weight profile holds the reference stats the recommendation algorithm
// targets when this app/game is selected. Keys match the option `value`s below.

export type OptionWeights = {
  cinebench_2024?: number;            // CPU raw performance
  review_power_efficiency?: number;   // CPU efficiency
  three_d_mark_time_spy_g?: number;   // GPU raw performance
  review_energy_efficiency?: number;  // GPU efficiency
  storage_size_gigabytes?: number;
  ram_size_gigabytes?: number;
  storage_type?: string;
};

export type AppGameOption = { value: string; label: string; image: string; category?: string };

export const SOFTWARE_WEIGHTS: Record<string, OptionWeights> = {
  "netflix": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "youtube": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "instagram": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "facebook": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "x-twitter": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "tiktok": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "reddit": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "twitch": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "linkedin": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "pinterest": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "canva": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-drive": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-meet": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "spotify-web": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "notion-web": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "slack": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "microsoft-teams": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "zoom": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "discord": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "gmail": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "outlook": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "whatsapp-desktop": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "telegram-desktop": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "signal-desktop": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "skype": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "adobe-photoshop": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "adobe-illustrator": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "adobe-premiere-pro": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 9113,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 72,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "adobe-after-effects": {
    "cinebench_2024": 1206,
    "three_d_mark_time_spy_g": 9113,
    "review_power_efficiency": 61,
    "review_energy_efficiency": 72,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "adobe-lightroom": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "adobe-xd": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "adobe-acrobat": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "davinci-resolve": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 9113,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 72,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "blender": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "autocad": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "fusion-360": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "figma": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "obs-studio": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "gimp": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "inkscape": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "cinema-4d": {
    "cinebench_2024": 1206,
    "three_d_mark_time_spy_g": 9113,
    "review_power_efficiency": 61,
    "review_energy_efficiency": 72,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "capcut": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "kdenlive": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "handbrake": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "microsoft-word": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "microsoft-excel": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "microsoft-powerpoint": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "power-bi-desktop": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "libreoffice": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "tableau-desktop": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "obsidian": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "notion-desktop": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-workspace": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "airtable": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "onenote": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "evernote": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "spotify-desktop": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "vlc-media-player": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "kodi": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "plex": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "audacity": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "apple-music": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "tidal": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "mpc-hc": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "winamp": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "visual-studio-code": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "intellij-idea": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "pycharm": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "webstorm": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "clion": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "android-studio": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "visual-studio-2022": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "github-desktop": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "docker-desktop": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "postman": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "sublime-text": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "cursor": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "google-chrome": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "mozilla-firefox": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "microsoft-edge": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "virtualbox": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "vmware-workstation": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "1password": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "bitwarden": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "dropbox": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "onedrive": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "filezilla": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "7-zip": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "sharex": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "zoom-video": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "chatgpt": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "claude": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-gemini": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "microsoft-copilot": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "perplexity": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "grammarly": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "trello": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "asana": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "jira": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "monday": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "clickup": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "miro": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "confluence": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "cisco-webex": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "loom": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "salesforce": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "hubspot": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "quickbooks": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "google-docs": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-sheets": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-calendar": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "quizlet": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "anki": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "zotero": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "overleaf": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "solidworks": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "ansys-workbench": {
    "cinebench_2024": 1206,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 61,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 64,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "matlab-simulink": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "autodesk-fusion-360": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "abaqus": {
    "cinebench_2024": 1206,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 61,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "excel-python": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 321,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "autodesk-revit": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "autodesk-inventor": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "comsol-multiphysics": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "catia": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "rhino-3d": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sketchup": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "ibm-spss-statistics": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "microsoft-365": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "siemens-nx": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "ptc-creo": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "openfoam": {
    "cinebench_2024": 2015,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 75,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 64,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "aspen-plus": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "aspen-hysys": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "gproms": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "labview": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "ni-multisim": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "orcad-pspice": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "altium-designer": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "cadence-virtuoso": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "kicad": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "ltspice": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "autocad-civil-3d": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "tekla-structures": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "sap2000-etabs": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "autodesk-robot-lusas": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "plaxis": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "archicad": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "enscape": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "lumion": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 19147,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 45,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "twinmotion": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "v-ray": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "3ds-max": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "keyshot": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "autodesk-alias": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "adobe-indesign": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "adobe-audition": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "avid-media-composer": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "final-cut-pro": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "adobe-creative-cloud": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "procreate": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "clo3d": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "touchdesigner": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "logic-pro": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "pro-tools": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "ableton-live": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sibelius-dorico": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "cubase-reaper": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "max-msp": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "kontakt": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "arcgis-pro": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "qgis": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "envi-erdas": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "agisoft-metashape": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 6241,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 56,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "petrel": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "leapfrog": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "surfer-grapher": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-earth-engine": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "simapro": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "chemdraw": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "gaussian-gaussview": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "avogadro-spartan": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "orca": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "vmd": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "mercury-ccdc": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "mestrenova": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "graphpad-prism": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "imagej-fiji": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "snapgene": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "geneious": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "3d-slicer": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "r-rstudio": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "stata": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "jasp": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "eviews": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "minitab": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "mathematica": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "maple": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "nvivo": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "atlas-ti": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "qualtrics": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "sas": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "python": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "java-jdk": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "c-cpp-toolchain": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "git": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "linux-wsl": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "nodejs-web": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sql-databases": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "pytorch-tensorflow": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "hadoop-spark": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "unity": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 11195,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 47,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "unreal-engine": {
    "cinebench_2024": 1572,
    "three_d_mark_time_spy_g": 19147,
    "review_power_efficiency": 80,
    "review_energy_efficiency": 45,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 1024,
    "storage_type": "SSD"
  },
  "fpga-vivado": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 32,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "jupyter-anaconda": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "complete-anatomy": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "psychopy": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "e-prime": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "kinovea": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "dartfish": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "quintic": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 3516,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 75,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "vicon-nexus": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5013,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 59,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "medicinescomplete-bnf": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "passmedicine-quesmed": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "bloomberg-terminal": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "refinitiv-eikon": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sage": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "sap-erp": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "legal-databases": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "capital-iq": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "google-analytics": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "praat": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "antconc": {
    "cinebench_2024": 366,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 60,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "elan": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "sdl-trados": {
    "cinebench_2024": 708,
    "three_d_mark_time_spy_g": 691,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 84,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  }
};

export const GAME_WEIGHTS: Record<string, OptionWeights> = {
  "counter-strike-2": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3427,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "apex-legends": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "pubg-battlegrounds": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "palworld": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "team-fortress-2": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "call-of-duty-modern-warfare-ii": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "new-world-aeternum": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "black-myth-wukong": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "grand-theft-auto-v": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "left-4-dead-2": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "unturned": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "lost-ark": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "war-thunder": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "monster-hunter-wilds": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "helldivers-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "warframe": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "elden-ring": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "terraria": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "path-of-exile-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "wallpaper-engine": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "baldur-s-gate-3": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "brawlhalla": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "garry-s-mod": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "destiny-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "tom-clancy-s-rainbow-six-siege": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "rust": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "world-of-warships": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "ark-survival-evolved": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "stardew-valley": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "the-forest": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "war-robots-frontiers": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "path-of-exile": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "payday-2": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "warface-clutch": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "grand-theft-auto-iv-complete-edition": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "last-epoch": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "half-life-2-lost-coast": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "cyberpunk-2077": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "dead-by-daylight": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "hogwarts-legacy": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "vrchat": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "the-witcher-3-wild-hunt": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "among-us": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "fall-guys": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "borderlands-2": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "euro-truck-simulator-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "valheim": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "phasmophobia": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "paladins": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "naraka-bladepoint": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "half-life-2-deathmatch": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "half-life": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "monster-hunter-world": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "heroes-generals": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "rocket-league": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "project-zomboid": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "lethal-company": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "red-dead-redemption-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "battlefield-2042": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "halo-infinite": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "raft": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "smite": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "world-of-tanks-blitz": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "counter-strike": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "counter-strike-source": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "schedule-i": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "ring-of-elysium": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "portal": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "the-sims-4": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "black-squad": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "don-t-starve-together": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "dying-light": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "human-fall-flat": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "7-days-to-die": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "counter-strike-condition-zero": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "efootball-2025": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "street-warriors-online": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "z1-battle-royale": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "hunt-showdown-1896": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sekiro-shadows-die-twice-goty-edition": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "cybercorp": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "half-life-2": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "arma-3": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sons-of-the-forest": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "grim-dawn": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "cities-skylines": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "mount-blade-ii-bannerlord": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sid-meier-s-civilization-v": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "trove": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sid-meier-s-civilization-vi": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "fallout-4": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "life-is-strange-2": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "warhammer-40-000-rogue-trader": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "battlefield-v": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "r-e-p-o": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "dayz": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "satisfactory": {
    "cinebench_2024": 1008,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 78,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "nba-2k20": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "risk-of-rain-2": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1118,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 79,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "ea-sports-fifa-23": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "minecraft": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "roblox": {
    "cinebench_2024": 452,
    "three_d_mark_time_spy_g": 787,
    "review_power_efficiency": 66,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 4,
    "storage_size_gigabytes": 128,
    "storage_type": "SSD"
  },
  "fortnite": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3427,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "league-of-legends": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "valorant": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "overwatch-2": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "dota-2": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "genshin-impact": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "world-of-warcraft": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "diablo-iv": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "marvel-rivals": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "call-of-duty-warzone": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "escape-from-tarkov": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "forza-horizon-5": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "final-fantasy-xiv": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "sea-of-thieves": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "starfield": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 9113,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 72,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "god-of-war-ragnarok": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "assassins-creed-shadows": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "honkai-star-rail": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "fc-26": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "arc-raiders": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "delta-force": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "battlefield-6": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "call-of-duty-black-ops-6": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "the-finals": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "kingdom-come-deliverance-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "clair-obscur-expedition-33": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "split-fiction": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "elden-ring-nightreign": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "stalker-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 9113,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 72,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "dune-awakening": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 9113,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 72,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "wuthering-waves": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "throne-and-liberty": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "once-human": {
    "cinebench_2024": 695,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 65,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "sid-meier-s-civilization-vii": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 3614,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 65,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "avowed": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "borderlands-4": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "marvels-spider-man-2": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 7534,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 512,
    "storage_type": "SSD"
  },
  "peak": {
    "cinebench_2024": 557,
    "three_d_mark_time_spy_g": 1682,
    "review_power_efficiency": 86,
    "review_energy_efficiency": 71,
    "ram_size_gigabytes": 8,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "inzoi": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  },
  "resident-evil-requiem": {
    "cinebench_2024": 846,
    "three_d_mark_time_spy_g": 5920,
    "review_power_efficiency": 52,
    "review_energy_efficiency": 46,
    "ram_size_gigabytes": 16,
    "storage_size_gigabytes": 256,
    "storage_type": "SSD"
  }
};

export const SOFTWARE_OPTIONS: AppGameOption[] = [
  {
    "value": "netflix",
    "label": "Netflix",
    "image": "https://www.google.com/s2/favicons?domain=netflix.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "youtube",
    "label": "YouTube",
    "image": "https://www.google.com/s2/favicons?domain=youtube.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "instagram",
    "label": "Instagram",
    "image": "https://www.google.com/s2/favicons?domain=instagram.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "facebook",
    "label": "Facebook",
    "image": "https://www.google.com/s2/favicons?domain=facebook.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "x-twitter",
    "label": "X (Twitter)",
    "image": "https://www.google.com/s2/favicons?domain=x.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "tiktok",
    "label": "TikTok",
    "image": "https://www.google.com/s2/favicons?domain=tiktok.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "reddit",
    "label": "Reddit",
    "image": "https://www.google.com/s2/favicons?domain=reddit.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "twitch",
    "label": "Twitch",
    "image": "https://www.google.com/s2/favicons?domain=twitch.tv&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "linkedin",
    "label": "LinkedIn",
    "image": "https://www.google.com/s2/favicons?domain=linkedin.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "pinterest",
    "label": "Pinterest",
    "image": "https://www.google.com/s2/favicons?domain=pinterest.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "canva",
    "label": "Canva",
    "image": "https://www.google.com/s2/favicons?domain=canva.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "google-drive",
    "label": "Google Drive",
    "image": "https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg",
    "category": "Browser Apps"
  },
  {
    "value": "google-meet",
    "label": "Google Meet",
    "image": "https://www.google.com/s2/favicons?domain=meet.google.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "spotify-web",
    "label": "Spotify Web",
    "image": "https://upload.wikimedia.org/wikipedia/commons/8/84/Spotify_icon.svg",
    "category": "Browser Apps"
  },
  {
    "value": "notion-web",
    "label": "Notion Web",
    "image": "https://www.google.com/s2/favicons?domain=notion.com&sz=256",
    "category": "Browser Apps"
  },
  {
    "value": "slack",
    "label": "Slack",
    "image": "https://www.google.com/s2/favicons?domain=slack.com&sz=256",
    "category": "Communication"
  },
  {
    "value": "microsoft-teams",
    "label": "Microsoft Teams",
    "image": "https://upload.wikimedia.org/wikipedia/commons/9/94/Microsoft_Office_Teams_%282019%E2%80%932025%29.svg",
    "category": "Communication"
  },
  {
    "value": "zoom",
    "label": "Zoom",
    "image": "https://www.google.com/s2/favicons?domain=zoom.us&sz=256",
    "category": "Communication"
  },
  {
    "value": "discord",
    "label": "Discord",
    "image": "https://www.google.com/s2/favicons?domain=discord.com&sz=256",
    "category": "Communication"
  },
  {
    "value": "gmail",
    "label": "Gmail",
    "image": "https://www.google.com/s2/favicons?domain=gmail.com&sz=256",
    "category": "Communication"
  },
  {
    "value": "outlook",
    "label": "Outlook",
    "image": "https://upload.wikimedia.org/wikipedia/commons/4/45/Microsoft_Office_Outlook_%282018%E2%80%932024%29.svg",
    "category": "Communication"
  },
  {
    "value": "whatsapp-desktop",
    "label": "WhatsApp Desktop",
    "image": "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
    "category": "Communication"
  },
  {
    "value": "telegram-desktop",
    "label": "Telegram Desktop",
    "image": "https://www.google.com/s2/favicons?domain=telegram.org&sz=256",
    "category": "Communication"
  },
  {
    "value": "signal-desktop",
    "label": "Signal Desktop",
    "image": "https://www.google.com/s2/favicons?domain=signal.org&sz=256",
    "category": "Communication"
  },
  {
    "value": "skype",
    "label": "Skype",
    "image": "https://upload.wikimedia.org/wikipedia/commons/6/60/Skype_logo_%282019%E2%80%93present%29.svg",
    "category": "Communication"
  },
  {
    "value": "adobe-photoshop",
    "label": "Adobe Photoshop",
    "image": "https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg",
    "category": "Content Creation"
  },
  {
    "value": "adobe-illustrator",
    "label": "Adobe Illustrator",
    "image": "https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg",
    "category": "Content Creation"
  },
  {
    "value": "adobe-premiere-pro",
    "label": "Adobe Premiere Pro",
    "image": "https://upload.wikimedia.org/wikipedia/commons/4/40/Adobe_Premiere_Pro_CC_icon.svg",
    "category": "Content Creation"
  },
  {
    "value": "adobe-after-effects",
    "label": "Adobe After Effects",
    "image": "https://upload.wikimedia.org/wikipedia/commons/c/cb/Adobe_After_Effects_CC_icon.svg",
    "category": "Content Creation"
  },
  {
    "value": "adobe-lightroom",
    "label": "Adobe Lightroom",
    "image": "https://upload.wikimedia.org/wikipedia/commons/b/b6/Adobe_Photoshop_Lightroom_CC_logo.svg",
    "category": "Content Creation"
  },
  {
    "value": "adobe-xd",
    "label": "Adobe XD",
    "image": "https://upload.wikimedia.org/wikipedia/commons/c/c2/Adobe_XD_CC_icon.svg",
    "category": "Content Creation"
  },
  {
    "value": "adobe-acrobat",
    "label": "Adobe Acrobat",
    "image": "https://upload.wikimedia.org/wikipedia/commons/0/0a/Adobe_Acrobat_DC_icon.svg",
    "category": "Content Creation"
  },
  {
    "value": "davinci-resolve",
    "label": "DaVinci Resolve",
    "image": "https://upload.wikimedia.org/wikipedia/commons/9/90/DaVinci_Resolve_17_logo.svg",
    "category": "Content Creation"
  },
  {
    "value": "blender",
    "label": "Blender",
    "image": "https://www.google.com/s2/favicons?domain=blender.org&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "autocad",
    "label": "AutoCAD",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "fusion-360",
    "label": "Fusion 360",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "figma",
    "label": "Figma",
    "image": "https://www.google.com/s2/favicons?domain=figma.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "obs-studio",
    "label": "OBS Studio",
    "image": "https://www.google.com/s2/favicons?domain=obsproject.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "gimp",
    "label": "GIMP",
    "image": "https://www.google.com/s2/favicons?domain=gimp.org&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "inkscape",
    "label": "Inkscape",
    "image": "https://upload.wikimedia.org/wikipedia/commons/0/0d/Inkscape_Logo.svg",
    "category": "Content Creation"
  },
  {
    "value": "cinema-4d",
    "label": "Cinema 4D",
    "image": "https://www.google.com/s2/favicons?domain=maxon.net&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "capcut",
    "label": "CapCut",
    "image": "https://www.google.com/s2/favicons?domain=capcut.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "kdenlive",
    "label": "Kdenlive",
    "image": "https://www.google.com/s2/favicons?domain=kdenlive.org&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "handbrake",
    "label": "HandBrake",
    "image": "https://www.google.com/s2/favicons?domain=handbrake.fr&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "microsoft-word",
    "label": "Microsoft Word",
    "image": "https://upload.wikimedia.org/wikipedia/commons/8/8d/Microsoft_Word_2013-2019_logo.svg",
    "category": "Office Software"
  },
  {
    "value": "microsoft-excel",
    "label": "Microsoft Excel",
    "image": "https://upload.wikimedia.org/wikipedia/commons/7/73/Microsoft_Excel_2013-2019_logo.svg",
    "category": "Office Software"
  },
  {
    "value": "microsoft-powerpoint",
    "label": "Microsoft PowerPoint",
    "image": "https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg",
    "category": "Office Software"
  },
  {
    "value": "power-bi-desktop",
    "label": "Power BI Desktop",
    "image": "https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg",
    "category": "Office Software"
  },
  {
    "value": "libreoffice",
    "label": "LibreOffice",
    "image": "https://upload.wikimedia.org/wikipedia/commons/0/02/LibreOffice_Logo_Flat.svg",
    "category": "Office Software"
  },
  {
    "value": "tableau-desktop",
    "label": "Tableau Desktop",
    "image": "https://www.google.com/s2/favicons?domain=tableau.com&sz=256",
    "category": "Office Software"
  },
  {
    "value": "obsidian",
    "label": "Obsidian",
    "image": "https://www.google.com/s2/favicons?domain=obsidian.md&sz=256",
    "category": "Office Software"
  },
  {
    "value": "notion-desktop",
    "label": "Notion Desktop",
    "image": "https://www.google.com/s2/favicons?domain=notion.com&sz=256",
    "category": "Office Software"
  },
  {
    "value": "google-workspace",
    "label": "Google Workspace",
    "image": "https://upload.wikimedia.org/wikipedia/commons/5/5f/Google_Workspace_Logo.svg",
    "category": "Office Software"
  },
  {
    "value": "airtable",
    "label": "Airtable",
    "image": "https://www.google.com/s2/favicons?domain=airtable.com&sz=256",
    "category": "Office Software"
  },
  {
    "value": "onenote",
    "label": "OneNote",
    "image": "https://upload.wikimedia.org/wikipedia/commons/9/91/Microsoft_OneNote_Logo_%282013-2019%29.svg",
    "category": "Office Software"
  },
  {
    "value": "evernote",
    "label": "Evernote",
    "image": "https://www.google.com/s2/favicons?domain=evernote.com&sz=256",
    "category": "Office Software"
  },
  {
    "value": "spotify-desktop",
    "label": "Spotify Desktop",
    "image": "https://upload.wikimedia.org/wikipedia/commons/8/84/Spotify_icon.svg",
    "category": "Entertainment"
  },
  {
    "value": "vlc-media-player",
    "label": "VLC Media Player",
    "image": "https://upload.wikimedia.org/wikipedia/commons/f/f9/VLC_Media_Player_%E2%80%93_Vlc_app_icon.svg",
    "category": "Entertainment"
  },
  {
    "value": "kodi",
    "label": "Kodi",
    "image": "https://www.google.com/s2/favicons?domain=kodi.tv&sz=256",
    "category": "Entertainment"
  },
  {
    "value": "plex",
    "label": "Plex",
    "image": "https://www.google.com/s2/favicons?domain=plex.tv&sz=256",
    "category": "Entertainment"
  },
  {
    "value": "audacity",
    "label": "Audacity",
    "image": "https://www.google.com/s2/favicons?domain=audacityteam.org&sz=256",
    "category": "Entertainment"
  },
  {
    "value": "apple-music",
    "label": "Apple Music",
    "image": "https://www.google.com/s2/favicons?domain=apple.com&sz=256",
    "category": "Entertainment"
  },
  {
    "value": "tidal",
    "label": "Tidal",
    "image": "https://www.google.com/s2/favicons?domain=tidal.com&sz=256",
    "category": "Entertainment"
  },
  {
    "value": "mpc-hc",
    "label": "MPC-HC",
    "image": "https://www.google.com/s2/favicons?domain=github.com&sz=256",
    "category": "Entertainment"
  },
  {
    "value": "winamp",
    "label": "Winamp",
    "image": "https://www.google.com/s2/favicons?domain=winamp.com&sz=256",
    "category": "Entertainment"
  },
  {
    "value": "visual-studio-code",
    "label": "Visual Studio Code",
    "image": "https://www.google.com/s2/favicons?domain=code.visualstudio.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "intellij-idea",
    "label": "IntelliJ IDEA",
    "image": "https://upload.wikimedia.org/wikipedia/commons/9/9c/IntelliJ_IDEA_Icon.svg",
    "category": "Coding"
  },
  {
    "value": "pycharm",
    "label": "PyCharm",
    "image": "https://upload.wikimedia.org/wikipedia/commons/1/1d/PyCharm_Icon.svg",
    "category": "Coding"
  },
  {
    "value": "webstorm",
    "label": "WebStorm",
    "image": "https://upload.wikimedia.org/wikipedia/commons/c/c0/WebStorm_Icon.svg",
    "category": "Coding"
  },
  {
    "value": "clion",
    "label": "CLion",
    "image": "https://upload.wikimedia.org/wikipedia/commons/6/62/Clion.svg",
    "category": "Coding"
  },
  {
    "value": "android-studio",
    "label": "Android Studio",
    "image": "https://upload.wikimedia.org/wikipedia/commons/c/c1/Android_Studio_icon_%282023%29.svg",
    "category": "Coding"
  },
  {
    "value": "visual-studio-2022",
    "label": "Visual Studio 2022",
    "image": "https://upload.wikimedia.org/wikipedia/commons/5/59/Visual_Studio_Icon_2019.svg",
    "category": "Coding"
  },
  {
    "value": "github-desktop",
    "label": "GitHub Desktop",
    "image": "https://www.google.com/s2/favicons?domain=github.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "docker-desktop",
    "label": "Docker Desktop",
    "image": "https://www.google.com/s2/favicons?domain=docker.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "postman",
    "label": "Postman",
    "image": "https://www.google.com/s2/favicons?domain=postman.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "sublime-text",
    "label": "Sublime Text",
    "image": "https://www.google.com/s2/favicons?domain=sublimetext.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "cursor",
    "label": "Cursor",
    "image": "https://www.google.com/s2/favicons?domain=cursor.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "google-chrome",
    "label": "Google Chrome",
    "image": "https://www.google.com/s2/favicons?domain=google.com&sz=256",
    "category": "Other"
  },
  {
    "value": "mozilla-firefox",
    "label": "Mozilla Firefox",
    "image": "https://www.google.com/s2/favicons?domain=mozilla.org&sz=256",
    "category": "Other"
  },
  {
    "value": "microsoft-edge",
    "label": "Microsoft Edge",
    "image": "https://upload.wikimedia.org/wikipedia/commons/9/98/Microsoft_Edge_logo_%282019%29.svg",
    "category": "Other"
  },
  {
    "value": "virtualbox",
    "label": "VirtualBox",
    "image": "https://www.google.com/s2/favicons?domain=virtualbox.org&sz=256",
    "category": "Other"
  },
  {
    "value": "vmware-workstation",
    "label": "VMware Workstation",
    "image": "https://www.google.com/s2/favicons?domain=vmware.com&sz=256",
    "category": "Other"
  },
  {
    "value": "1password",
    "label": "1Password",
    "image": "https://www.google.com/s2/favicons?domain=1password.com&sz=256",
    "category": "Other"
  },
  {
    "value": "bitwarden",
    "label": "Bitwarden",
    "image": "https://www.google.com/s2/favicons?domain=bitwarden.com&sz=256",
    "category": "Other"
  },
  {
    "value": "dropbox",
    "label": "Dropbox",
    "image": "https://www.google.com/s2/favicons?domain=dropbox.com&sz=256",
    "category": "Other"
  },
  {
    "value": "onedrive",
    "label": "OneDrive",
    "image": "https://upload.wikimedia.org/wikipedia/commons/6/60/Microsoft_Office_OneDrive_%282014-2019%29.svg",
    "category": "Other"
  },
  {
    "value": "filezilla",
    "label": "FileZilla",
    "image": "https://www.google.com/s2/favicons?domain=filezilla-project.org&sz=256",
    "category": "Other"
  },
  {
    "value": "7-zip",
    "label": "7-Zip",
    "image": "https://www.google.com/s2/favicons?domain=7-zip.org&sz=256",
    "category": "Other"
  },
  {
    "value": "sharex",
    "label": "ShareX",
    "image": "https://www.google.com/s2/favicons?domain=getsharex.com&sz=256",
    "category": "Other"
  },
  {
    "value": "zoom-video",
    "label": "Zoom (Video)",
    "image": "https://www.google.com/s2/favicons?domain=zoom.us&sz=256",
    "category": "Other"
  },
  {
    "value": "chatgpt",
    "label": "ChatGPT",
    "image": "https://www.google.com/s2/favicons?domain=chatgpt.com&sz=256",
    "category": "AI Assistants"
  },
  {
    "value": "claude",
    "label": "Claude",
    "image": "https://www.google.com/s2/favicons?domain=claude.ai&sz=256",
    "category": "AI Assistants"
  },
  {
    "value": "google-gemini",
    "label": "Google Gemini",
    "image": "https://www.google.com/s2/favicons?domain=gemini.google.com&sz=256",
    "category": "AI Assistants"
  },
  {
    "value": "microsoft-copilot",
    "label": "Microsoft Copilot",
    "image": "https://www.google.com/s2/favicons?domain=copilot.microsoft.com&sz=256",
    "category": "AI Assistants"
  },
  {
    "value": "perplexity",
    "label": "Perplexity",
    "image": "https://www.google.com/s2/favicons?domain=perplexity.ai&sz=256",
    "category": "AI Assistants"
  },
  {
    "value": "grammarly",
    "label": "Grammarly",
    "image": "https://www.google.com/s2/favicons?domain=grammarly.com&sz=256",
    "category": "AI Assistants"
  },
  {
    "value": "trello",
    "label": "Trello",
    "image": "https://www.google.com/s2/favicons?domain=trello.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "asana",
    "label": "Asana",
    "image": "https://www.google.com/s2/favicons?domain=asana.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "jira",
    "label": "Jira",
    "image": "https://upload.wikimedia.org/wikipedia/commons/8/82/Jira_%28Software%29_logo.svg",
    "category": "Productivity & Business"
  },
  {
    "value": "monday",
    "label": "Monday.com",
    "image": "https://www.google.com/s2/favicons?domain=monday.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "clickup",
    "label": "ClickUp",
    "image": "https://www.google.com/s2/favicons?domain=clickup.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "miro",
    "label": "Miro",
    "image": "https://www.google.com/s2/favicons?domain=miro.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "confluence",
    "label": "Confluence",
    "image": "https://upload.wikimedia.org/wikipedia/commons/8/88/Atlassian_Confluence_2017_logo.svg",
    "category": "Productivity & Business"
  },
  {
    "value": "cisco-webex",
    "label": "Cisco Webex",
    "image": "https://www.google.com/s2/favicons?domain=webex.com&sz=256",
    "category": "Communication"
  },
  {
    "value": "loom",
    "label": "Loom",
    "image": "https://www.google.com/s2/favicons?domain=loom.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "salesforce",
    "label": "Salesforce",
    "image": "https://www.google.com/s2/favicons?domain=salesforce.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "hubspot",
    "label": "HubSpot",
    "image": "https://www.google.com/s2/favicons?domain=hubspot.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "quickbooks",
    "label": "QuickBooks",
    "image": "https://www.google.com/s2/favicons?domain=quickbooks.intuit.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "google-docs",
    "label": "Google Docs",
    "image": "https://upload.wikimedia.org/wikipedia/commons/6/66/Google_Docs_2020_Logo.svg",
    "category": "Office Software"
  },
  {
    "value": "google-sheets",
    "label": "Google Sheets",
    "image": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Google_Sheets_2020_Logo.svg",
    "category": "Office Software"
  },
  {
    "value": "google-calendar",
    "label": "Google Calendar",
    "image": "https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Calendar_icon_%282020%29.svg",
    "category": "Office Software"
  },
  {
    "value": "quizlet",
    "label": "Quizlet",
    "image": "https://www.google.com/s2/favicons?domain=quizlet.com&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "anki",
    "label": "Anki",
    "image": "https://www.google.com/s2/favicons?domain=apps.ankiweb.net&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "zotero",
    "label": "Zotero",
    "image": "https://www.google.com/s2/favicons?domain=zotero.org&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "overleaf",
    "label": "Overleaf",
    "image": "https://www.google.com/s2/favicons?domain=overleaf.com&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "solidworks",
    "label": "SolidWorks",
    "image": "https://www.google.com/s2/favicons?domain=solidworks.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "ansys-workbench",
    "label": "ANSYS Workbench",
    "image": "https://www.google.com/s2/favicons?domain=ansys.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "matlab-simulink",
    "label": "MATLAB/Simulink",
    "image": "https://www.google.com/s2/favicons?domain=mathworks.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "autodesk-fusion-360",
    "label": "Autodesk Fusion 360",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "abaqus",
    "label": "Abaqus",
    "image": "https://www.google.com/s2/favicons?domain=3ds.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "excel-python",
    "label": "Excel / Python (data analysis)",
    "image": "https://www.google.com/s2/favicons?domain=python.org&sz=256",
    "category": "Engineering"
  },
  {
    "value": "autodesk-revit",
    "label": "Autodesk Revit",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "autodesk-inventor",
    "label": "Autodesk Inventor",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "comsol-multiphysics",
    "label": "COMSOL Multiphysics",
    "image": "https://www.google.com/s2/favicons?domain=comsol.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "catia",
    "label": "CATIA",
    "image": "https://www.google.com/s2/favicons?domain=3ds.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "rhino-3d",
    "label": "Rhino 3D",
    "image": "https://www.google.com/s2/favicons?domain=rhino3d.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "sketchup",
    "label": "SketchUp",
    "image": "https://www.google.com/s2/favicons?domain=sketchup.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "ibm-spss-statistics",
    "label": "IBM SPSS Statistics",
    "image": "https://www.google.com/s2/favicons?domain=ibm.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "microsoft-365",
    "label": "Microsoft 365 (Office)",
    "image": "https://www.google.com/s2/favicons?domain=microsoft365.com&sz=256",
    "category": "Office Software"
  },
  {
    "value": "siemens-nx",
    "label": "Siemens NX",
    "image": "https://www.google.com/s2/favicons?domain=sw.siemens.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "ptc-creo",
    "label": "PTC Creo",
    "image": "https://www.google.com/s2/favicons?domain=ptc.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "openfoam",
    "label": "OpenFOAM",
    "image": "https://www.google.com/s2/favicons?domain=openfoam.org&sz=256",
    "category": "Engineering"
  },
  {
    "value": "aspen-plus",
    "label": "Aspen Plus",
    "image": "https://www.google.com/s2/favicons?domain=aspentech.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "aspen-hysys",
    "label": "Aspen HYSYS",
    "image": "https://www.google.com/s2/favicons?domain=aspentech.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "gproms",
    "label": "gPROMS",
    "image": "https://www.google.com/s2/favicons?domain=siemens.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "labview",
    "label": "LabVIEW",
    "image": "https://www.google.com/s2/favicons?domain=ni.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "ni-multisim",
    "label": "NI Multisim",
    "image": "https://www.google.com/s2/favicons?domain=ni.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "orcad-pspice",
    "label": "OrCAD PSpice",
    "image": "https://www.google.com/s2/favicons?domain=cadence.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "altium-designer",
    "label": "Altium Designer",
    "image": "https://www.google.com/s2/favicons?domain=altium.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "cadence-virtuoso",
    "label": "Cadence Virtuoso",
    "image": "https://www.google.com/s2/favicons?domain=cadence.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "kicad",
    "label": "KiCad",
    "image": "https://www.google.com/s2/favicons?domain=kicad.org&sz=256",
    "category": "Engineering"
  },
  {
    "value": "ltspice",
    "label": "LTspice",
    "image": "https://www.google.com/s2/favicons?domain=analog.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "autocad-civil-3d",
    "label": "AutoCAD Civil 3D",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "tekla-structures",
    "label": "Tekla Structures",
    "image": "https://www.google.com/s2/favicons?domain=tekla.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "sap2000-etabs",
    "label": "SAP2000 / ETABS",
    "image": "https://www.google.com/s2/favicons?domain=csiamerica.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "autodesk-robot-lusas",
    "label": "Autodesk Robot / LUSAS",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "plaxis",
    "label": "PLAXIS",
    "image": "https://www.google.com/s2/favicons?domain=bentley.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "archicad",
    "label": "ArchiCAD",
    "image": "https://www.google.com/s2/favicons?domain=graphisoft.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "enscape",
    "label": "Enscape",
    "image": "https://www.google.com/s2/favicons?domain=enscape3d.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "lumion",
    "label": "Lumion",
    "image": "https://www.google.com/s2/favicons?domain=lumion.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "twinmotion",
    "label": "Twinmotion",
    "image": "https://www.google.com/s2/favicons?domain=twinmotion.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "v-ray",
    "label": "V-Ray",
    "image": "https://www.google.com/s2/favicons?domain=chaos.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "3ds-max",
    "label": "Autodesk 3ds Max",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "keyshot",
    "label": "KeyShot",
    "image": "https://www.google.com/s2/favicons?domain=keyshot.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "autodesk-alias",
    "label": "Autodesk Alias",
    "image": "https://www.google.com/s2/favicons?domain=autodesk.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "adobe-indesign",
    "label": "Adobe InDesign",
    "image": "https://upload.wikimedia.org/wikipedia/commons/4/48/Adobe_InDesign_CC_icon.svg",
    "category": "Content Creation"
  },
  {
    "value": "adobe-audition",
    "label": "Adobe Audition",
    "image": "https://www.google.com/s2/favicons?domain=adobe.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "avid-media-composer",
    "label": "Avid Media Composer",
    "image": "https://www.google.com/s2/favicons?domain=avid.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "final-cut-pro",
    "label": "Final Cut Pro",
    "image": "https://www.google.com/s2/favicons?domain=apple.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "adobe-creative-cloud",
    "label": "Adobe Creative Cloud (imaging apps)",
    "image": "https://www.google.com/s2/favicons?domain=adobe.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "procreate",
    "label": "Procreate",
    "image": "https://www.google.com/s2/favicons?domain=procreate.com&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "clo3d",
    "label": "CLO3D",
    "image": "https://www.google.com/s2/favicons?domain=clo3d.com&sz=256",
    "category": "Architecture & Design"
  },
  {
    "value": "touchdesigner",
    "label": "TouchDesigner",
    "image": "https://www.google.com/s2/favicons?domain=derivative.ca&sz=256",
    "category": "Content Creation"
  },
  {
    "value": "logic-pro",
    "label": "Logic Pro",
    "image": "https://www.google.com/s2/favicons?domain=apple.com&sz=256",
    "category": "Music & Audio"
  },
  {
    "value": "pro-tools",
    "label": "Pro Tools",
    "image": "https://www.google.com/s2/favicons?domain=avid.com&sz=256",
    "category": "Music & Audio"
  },
  {
    "value": "ableton-live",
    "label": "Ableton Live",
    "image": "https://www.google.com/s2/favicons?domain=ableton.com&sz=256",
    "category": "Music & Audio"
  },
  {
    "value": "sibelius-dorico",
    "label": "Sibelius / Dorico",
    "image": "https://www.google.com/s2/favicons?domain=avid.com&sz=256",
    "category": "Music & Audio"
  },
  {
    "value": "cubase-reaper",
    "label": "Cubase / Reaper",
    "image": "https://www.google.com/s2/favicons?domain=steinberg.net&sz=256",
    "category": "Music & Audio"
  },
  {
    "value": "max-msp",
    "label": "Max/MSP",
    "image": "https://www.google.com/s2/favicons?domain=cycling74.com&sz=256",
    "category": "Music & Audio"
  },
  {
    "value": "kontakt",
    "label": "Kontakt",
    "image": "https://www.google.com/s2/favicons?domain=native-instruments.com&sz=256",
    "category": "Music & Audio"
  },
  {
    "value": "arcgis-pro",
    "label": "ArcGIS Pro",
    "image": "https://www.google.com/s2/favicons?domain=esri.com&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "qgis",
    "label": "QGIS",
    "image": "https://www.google.com/s2/favicons?domain=qgis.org&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "envi-erdas",
    "label": "ENVI / ERDAS Imagine",
    "image": "https://www.google.com/s2/favicons?domain=nv5.com&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "agisoft-metashape",
    "label": "Agisoft Metashape",
    "image": "https://www.google.com/s2/favicons?domain=agisoft.com&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "petrel",
    "label": "Petrel (SLB)",
    "image": "https://www.google.com/s2/favicons?domain=slb.com&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "leapfrog",
    "label": "Leapfrog (Seequent)",
    "image": "https://www.google.com/s2/favicons?domain=seequent.com&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "surfer-grapher",
    "label": "Surfer / Grapher (Golden Software)",
    "image": "https://www.google.com/s2/favicons?domain=goldensoftware.com&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "google-earth-engine",
    "label": "Google Earth Engine",
    "image": "https://www.google.com/s2/favicons?domain=earthengine.google.com&sz=256",
    "category": "GIS & Geoscience"
  },
  {
    "value": "simapro",
    "label": "SimaPro",
    "image": "https://www.google.com/s2/favicons?domain=simapro.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "chemdraw",
    "label": "ChemDraw",
    "image": "https://www.google.com/s2/favicons?domain=revvitysignals.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "gaussian-gaussview",
    "label": "Gaussian / GaussView",
    "image": "https://www.google.com/s2/favicons?domain=gaussian.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "avogadro-spartan",
    "label": "Avogadro / Spartan",
    "image": "https://www.google.com/s2/favicons?domain=wavefun.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "orca",
    "label": "ORCA",
    "image": "https://www.google.com/s2/favicons?domain=faccts.de&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "vmd",
    "label": "VMD",
    "image": "https://www.google.com/s2/favicons?domain=illinois.edu&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "mercury-ccdc",
    "label": "Mercury (CCDC)",
    "image": "https://www.google.com/s2/favicons?domain=ccdc.cam.ac.uk&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "mestrenova",
    "label": "MestReNova",
    "image": "https://www.google.com/s2/favicons?domain=mestrelab.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "graphpad-prism",
    "label": "GraphPad Prism",
    "image": "https://www.google.com/s2/favicons?domain=graphpad.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "imagej-fiji",
    "label": "ImageJ / Fiji",
    "image": "https://www.google.com/s2/favicons?domain=imagej.net&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "snapgene",
    "label": "SnapGene",
    "image": "https://www.google.com/s2/favicons?domain=snapgene.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "geneious",
    "label": "Geneious Prime",
    "image": "https://www.google.com/s2/favicons?domain=geneious.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "3d-slicer",
    "label": "3D Slicer",
    "image": "https://www.google.com/s2/favicons?domain=slicer.org&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "r-rstudio",
    "label": "R / RStudio",
    "image": "https://www.google.com/s2/favicons?domain=posit.co&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "stata",
    "label": "Stata",
    "image": "https://www.google.com/s2/favicons?domain=stata.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "jasp",
    "label": "JASP",
    "image": "https://www.google.com/s2/favicons?domain=jasp-stats.org&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "eviews",
    "label": "EViews",
    "image": "https://www.google.com/s2/favicons?domain=eviews.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "minitab",
    "label": "Minitab",
    "image": "https://www.google.com/s2/favicons?domain=minitab.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "mathematica",
    "label": "Wolfram Mathematica",
    "image": "https://www.google.com/s2/favicons?domain=wolfram.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "maple",
    "label": "Maple",
    "image": "https://www.google.com/s2/favicons?domain=maplesoft.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "nvivo",
    "label": "NVivo",
    "image": "https://www.google.com/s2/favicons?domain=lumivero.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "atlas-ti",
    "label": "ATLAS.ti",
    "image": "https://www.google.com/s2/favicons?domain=atlasti.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "qualtrics",
    "label": "Qualtrics",
    "image": "https://www.google.com/s2/favicons?domain=qualtrics.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "sas",
    "label": "SAS",
    "image": "https://www.google.com/s2/favicons?domain=sas.com&sz=256",
    "category": "Data & Statistics"
  },
  {
    "value": "python",
    "label": "Python",
    "image": "https://www.google.com/s2/favicons?domain=python.org&sz=256",
    "category": "Coding"
  },
  {
    "value": "java-jdk",
    "label": "Java (JDK)",
    "image": "https://www.google.com/s2/favicons?domain=java.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "c-cpp-toolchain",
    "label": "C / C++ toolchain (GCC/Clang/MSVC)",
    "image": "https://www.google.com/s2/favicons?domain=isocpp.org&sz=256",
    "category": "Coding"
  },
  {
    "value": "git",
    "label": "Git",
    "image": "https://www.google.com/s2/favicons?domain=git-scm.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "linux-wsl",
    "label": "Linux / WSL environment",
    "image": "https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg",
    "category": "Coding"
  },
  {
    "value": "nodejs-web",
    "label": "Node.js / JavaScript / React",
    "image": "https://www.google.com/s2/favicons?domain=nodejs.org&sz=256",
    "category": "Coding"
  },
  {
    "value": "sql-databases",
    "label": "SQL databases (MySQL/PostgreSQL)",
    "image": "https://www.google.com/s2/favicons?domain=postgresql.org&sz=256",
    "category": "Coding"
  },
  {
    "value": "pytorch-tensorflow",
    "label": "PyTorch / TensorFlow (deep learning)",
    "image": "https://www.google.com/s2/favicons?domain=pytorch.org&sz=256",
    "category": "Coding"
  },
  {
    "value": "hadoop-spark",
    "label": "Hadoop / Spark (big data)",
    "image": "https://www.google.com/s2/favicons?domain=spark.apache.org&sz=256",
    "category": "Coding"
  },
  {
    "value": "unity",
    "label": "Unity",
    "image": "https://www.google.com/s2/favicons?domain=unity.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "unreal-engine",
    "label": "Unreal Engine 5",
    "image": "https://www.google.com/s2/favicons?domain=unrealengine.com&sz=256",
    "category": "Coding"
  },
  {
    "value": "fpga-vivado",
    "label": "Xilinx Vivado / FPGA tools",
    "image": "https://www.google.com/s2/favicons?domain=amd.com&sz=256",
    "category": "Engineering"
  },
  {
    "value": "jupyter-anaconda",
    "label": "Jupyter / Anaconda (Python data science)",
    "image": "https://www.google.com/s2/favicons?domain=jupyter.org&sz=256",
    "category": "Coding"
  },
  {
    "value": "complete-anatomy",
    "label": "Complete Anatomy",
    "image": "https://www.google.com/s2/favicons?domain=3d4medical.com&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "psychopy",
    "label": "PsychoPy",
    "image": "https://www.google.com/s2/favicons?domain=psychopy.org&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "e-prime",
    "label": "E-Prime",
    "image": "https://www.google.com/s2/favicons?domain=pstnet.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "kinovea",
    "label": "Kinovea",
    "image": "https://www.google.com/s2/favicons?domain=kinovea.org&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "dartfish",
    "label": "Dartfish",
    "image": "https://www.google.com/s2/favicons?domain=dartfish.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "quintic",
    "label": "Quintic",
    "image": "https://www.google.com/s2/favicons?domain=quinticsports.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "vicon-nexus",
    "label": "Vicon Nexus",
    "image": "https://www.google.com/s2/favicons?domain=vicon.com&sz=256",
    "category": "Science & Lab"
  },
  {
    "value": "medicinescomplete-bnf",
    "label": "MedicinesComplete / BNF",
    "image": "https://www.google.com/s2/favicons?domain=nice.org.uk&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "passmedicine-quesmed",
    "label": "PassMedicine / Quesmed",
    "image": "https://www.google.com/s2/favicons?domain=passmedicine.com&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "bloomberg-terminal",
    "label": "Bloomberg Terminal",
    "image": "https://www.google.com/s2/favicons?domain=bloomberg.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "refinitiv-eikon",
    "label": "Refinitiv Eikon (LSEG)",
    "image": "https://www.google.com/s2/favicons?domain=lseg.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "sage",
    "label": "Sage Accounting",
    "image": "https://www.google.com/s2/favicons?domain=sage.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "sap-erp",
    "label": "SAP (ERP / SAP GUI)",
    "image": "https://www.google.com/s2/favicons?domain=sap.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "legal-databases",
    "label": "Westlaw / LexisNexis / Practical Law (legal databases)",
    "image": "https://www.google.com/s2/favicons?domain=thomsonreuters.com&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "capital-iq",
    "label": "S&P Capital IQ",
    "image": "https://www.google.com/s2/favicons?domain=spglobal.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "google-analytics",
    "label": "Google Analytics",
    "image": "https://www.google.com/s2/favicons?domain=analytics.google.com&sz=256",
    "category": "Productivity & Business"
  },
  {
    "value": "praat",
    "label": "Praat",
    "image": "https://www.google.com/s2/favicons?domain=praat.org&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "antconc",
    "label": "AntConc",
    "image": "https://www.google.com/s2/favicons?domain=laurenceanthony.net&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "elan",
    "label": "ELAN",
    "image": "https://www.google.com/s2/favicons?domain=archive.mpi.nl&sz=256",
    "category": "Education & Research"
  },
  {
    "value": "sdl-trados",
    "label": "SDL Trados Studio",
    "image": "https://www.google.com/s2/favicons?domain=trados.com&sz=256",
    "category": "Education & Research"
  }
];

export const GAME_OPTIONS: AppGameOption[] = [
  {
    "value": "counter-strike-2",
    "label": "Counter-Strike 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/730/library_600x900.jpg"
  },
  {
    "value": "apex-legends",
    "label": "Apex Legends",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1172470/library_600x900.jpg"
  },
  {
    "value": "pubg-battlegrounds",
    "label": "PUBG: BATTLEGROUNDS",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/578080/library_600x900.jpg"
  },
  {
    "value": "palworld",
    "label": "Palworld",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1623730/library_600x900.jpg"
  },
  {
    "value": "team-fortress-2",
    "label": "Team Fortress 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/440/library_600x900.jpg"
  },
  {
    "value": "call-of-duty-modern-warfare-ii",
    "label": "Call of Duty: Modern Warfare II",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1938090/library_600x900.jpg"
  },
  {
    "value": "new-world-aeternum",
    "label": "New World: Aeternum",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1063730/library_600x900.jpg"
  },
  {
    "value": "black-myth-wukong",
    "label": "Black Myth: Wukong",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2358720/library_600x900.jpg"
  },
  {
    "value": "grand-theft-auto-v",
    "label": "Grand Theft Auto V",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/271590/library_600x900.jpg"
  },
  {
    "value": "left-4-dead-2",
    "label": "Left 4 Dead 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/550/library_600x900.jpg"
  },
  {
    "value": "unturned",
    "label": "Unturned",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/304930/library_600x900.jpg"
  },
  {
    "value": "lost-ark",
    "label": "Lost Ark",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1599340/library_600x900.jpg"
  },
  {
    "value": "war-thunder",
    "label": "War Thunder",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/236390/library_600x900.jpg"
  },
  {
    "value": "monster-hunter-wilds",
    "label": "Monster Hunter Wilds",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2246340/library_600x900.jpg"
  },
  {
    "value": "helldivers-2",
    "label": "HELLDIVERS 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/553850/library_600x900.jpg"
  },
  {
    "value": "warframe",
    "label": "Warframe",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/230410/library_600x900.jpg"
  },
  {
    "value": "elden-ring",
    "label": "ELDEN RING",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1245620/library_600x900.jpg"
  },
  {
    "value": "terraria",
    "label": "Terraria",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/105600/library_600x900.jpg"
  },
  {
    "value": "path-of-exile-2",
    "label": "Path of Exile 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2694490/library_600x900.jpg"
  },
  {
    "value": "wallpaper-engine",
    "label": "Wallpaper Engine",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/431960/library_600x900.jpg"
  },
  {
    "value": "baldur-s-gate-3",
    "label": "Baldur's Gate 3",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1086940/library_600x900.jpg"
  },
  {
    "value": "brawlhalla",
    "label": "Brawlhalla",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/291550/library_600x900.jpg"
  },
  {
    "value": "garry-s-mod",
    "label": "Garry's Mod",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/4000/library_600x900.jpg"
  },
  {
    "value": "destiny-2",
    "label": "Destiny 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1085660/library_600x900.jpg"
  },
  {
    "value": "tom-clancy-s-rainbow-six-siege",
    "label": "Tom Clancy's Rainbow Six Siege",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/359550/library_600x900.jpg"
  },
  {
    "value": "rust",
    "label": "Rust",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/252490/library_600x900.jpg"
  },
  {
    "value": "world-of-warships",
    "label": "World of Warships",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/552990/library_600x900.jpg"
  },
  {
    "value": "ark-survival-evolved",
    "label": "ARK: Survival Evolved",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/346110/library_600x900.jpg"
  },
  {
    "value": "stardew-valley",
    "label": "Stardew Valley",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/413150/library_600x900.jpg"
  },
  {
    "value": "the-forest",
    "label": "The Forest",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/242760/library_600x900.jpg"
  },
  {
    "value": "war-robots-frontiers",
    "label": "War Robots: Frontiers",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1491000/library_600x900.jpg"
  },
  {
    "value": "path-of-exile",
    "label": "Path of Exile",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/238960/library_600x900.jpg"
  },
  {
    "value": "payday-2",
    "label": "PAYDAY 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/218620/library_600x900.jpg"
  },
  {
    "value": "warface-clutch",
    "label": "Warface: Clutch",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/291480/library_600x900.jpg"
  },
  {
    "value": "grand-theft-auto-iv-complete-edition",
    "label": "Grand Theft Auto IV: Complete Edition",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/901583/library_600x900.jpg"
  },
  {
    "value": "last-epoch",
    "label": "Last Epoch",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/899770/library_600x900.jpg"
  },
  {
    "value": "half-life-2-lost-coast",
    "label": "Half-Life 2: Lost Coast",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/340/library_600x900.jpg"
  },
  {
    "value": "cyberpunk-2077",
    "label": "Cyberpunk 2077",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1091500/library_600x900.jpg"
  },
  {
    "value": "dead-by-daylight",
    "label": "Dead by Daylight",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/381210/library_600x900.jpg"
  },
  {
    "value": "hogwarts-legacy",
    "label": "Hogwarts Legacy",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/990080/library_600x900.jpg"
  },
  {
    "value": "vrchat",
    "label": "VRChat",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/438100/library_600x900.jpg"
  },
  {
    "value": "the-witcher-3-wild-hunt",
    "label": "The Witcher 3: Wild Hunt",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/292030/library_600x900.jpg"
  },
  {
    "value": "among-us",
    "label": "Among Us",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/945360/library_600x900.jpg"
  },
  {
    "value": "fall-guys",
    "label": "Fall Guys",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1097150/library_600x900.jpg"
  },
  {
    "value": "borderlands-2",
    "label": "Borderlands 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/49520/library_600x900.jpg"
  },
  {
    "value": "euro-truck-simulator-2",
    "label": "Euro Truck Simulator 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/227300/library_600x900.jpg"
  },
  {
    "value": "valheim",
    "label": "Valheim",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/892970/library_600x900.jpg"
  },
  {
    "value": "phasmophobia",
    "label": "Phasmophobia",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/739630/library_600x900.jpg"
  },
  {
    "value": "paladins",
    "label": "Paladins",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/444090/library_600x900.jpg"
  },
  {
    "value": "naraka-bladepoint",
    "label": "NARAKA: BLADEPOINT",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1203220/library_600x900.jpg"
  },
  {
    "value": "half-life-2-deathmatch",
    "label": "Half-Life 2: Deathmatch",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/320/library_600x900.jpg"
  },
  {
    "value": "half-life",
    "label": "Half-Life",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/70/library_600x900.jpg"
  },
  {
    "value": "monster-hunter-world",
    "label": "Monster Hunter: World",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/582010/library_600x900.jpg"
  },
  {
    "value": "heroes-generals",
    "label": "Heroes & Generals",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/227940/library_600x900.jpg"
  },
  {
    "value": "rocket-league",
    "label": "Rocket League",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/252950/library_600x900.jpg"
  },
  {
    "value": "project-zomboid",
    "label": "Project Zomboid",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/108600/library_600x900.jpg"
  },
  {
    "value": "lethal-company",
    "label": "Lethal Company",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1966720/library_600x900.jpg"
  },
  {
    "value": "red-dead-redemption-2",
    "label": "Red Dead Redemption 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1174180/library_600x900.jpg"
  },
  {
    "value": "battlefield-2042",
    "label": "Battlefield 2042",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1517290/library_600x900.jpg"
  },
  {
    "value": "halo-infinite",
    "label": "Halo Infinite",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1240440/library_600x900.jpg"
  },
  {
    "value": "raft",
    "label": "Raft",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/648800/library_600x900.jpg"
  },
  {
    "value": "smite",
    "label": "SMITE",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/386360/library_600x900.jpg"
  },
  {
    "value": "world-of-tanks-blitz",
    "label": "World of Tanks Blitz",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/444200/library_600x900.jpg"
  },
  {
    "value": "counter-strike",
    "label": "Counter-Strike",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/10/library_600x900.jpg"
  },
  {
    "value": "counter-strike-source",
    "label": "Counter-Strike: Source",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/240/library_600x900.jpg"
  },
  {
    "value": "schedule-i",
    "label": "Schedule I",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/3164500/library_600x900.jpg"
  },
  {
    "value": "ring-of-elysium",
    "label": "Ring of Elysium",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/755790/library_600x900.jpg"
  },
  {
    "value": "portal",
    "label": "Portal",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/400/library_600x900.jpg"
  },
  {
    "value": "the-sims-4",
    "label": "The Sims 4",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1222670/library_600x900.jpg"
  },
  {
    "value": "black-squad",
    "label": "Black Squad",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/550650/library_600x900.jpg"
  },
  {
    "value": "don-t-starve-together",
    "label": "Don't Starve Together",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/322330/library_600x900.jpg"
  },
  {
    "value": "dying-light",
    "label": "Dying Light",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/239140/library_600x900.jpg"
  },
  {
    "value": "human-fall-flat",
    "label": "Human Fall Flat",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/477160/library_600x900.jpg"
  },
  {
    "value": "7-days-to-die",
    "label": "7 Days to Die",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/251570/library_600x900.jpg"
  },
  {
    "value": "counter-strike-condition-zero",
    "label": "Counter-Strike: Condition Zero",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/100/library_600x900.jpg"
  },
  {
    "value": "efootball-2025",
    "label": "eFootball 2025",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1665460/library_600x900.jpg"
  },
  {
    "value": "street-warriors-online",
    "label": "Street Warriors Online",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/417910/library_600x900.jpg"
  },
  {
    "value": "z1-battle-royale",
    "label": "Z1 Battle Royale",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/433850/library_600x900.jpg"
  },
  {
    "value": "hunt-showdown-1896",
    "label": "Hunt: Showdown 1896",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/594650/library_600x900.jpg"
  },
  {
    "value": "sekiro-shadows-die-twice-goty-edition",
    "label": "Sekiro: Shadows Die Twice - GOTY Edition",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/814380/library_600x900.jpg"
  },
  {
    "value": "cybercorp",
    "label": "CyberCorp",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1116170/library_600x900.jpg"
  },
  {
    "value": "half-life-2",
    "label": "Half-Life 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/220/library_600x900.jpg"
  },
  {
    "value": "arma-3",
    "label": "Arma 3",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/107410/library_600x900.jpg"
  },
  {
    "value": "sons-of-the-forest",
    "label": "Sons Of The Forest",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1326470/library_600x900.jpg"
  },
  {
    "value": "grim-dawn",
    "label": "Grim Dawn",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/219990/library_600x900.jpg"
  },
  {
    "value": "cities-skylines",
    "label": "Cities: Skylines",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/255710/library_600x900.jpg"
  },
  {
    "value": "mount-blade-ii-bannerlord",
    "label": "Mount & Blade II: Bannerlord",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/261550/library_600x900.jpg"
  },
  {
    "value": "sid-meier-s-civilization-v",
    "label": "Sid Meier's Civilization V",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/8930/library_600x900.jpg"
  },
  {
    "value": "trove",
    "label": "Trove",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/304050/library_600x900.jpg"
  },
  {
    "value": "sid-meier-s-civilization-vi",
    "label": "Sid Meier's Civilization VI",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/289070/library_600x900.jpg"
  },
  {
    "value": "fallout-4",
    "label": "Fallout 4",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/377160/library_600x900.jpg"
  },
  {
    "value": "life-is-strange-2",
    "label": "Life is Strange 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/532210/library_600x900.jpg"
  },
  {
    "value": "warhammer-40-000-rogue-trader",
    "label": "Warhammer 40,000: Rogue Trader",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2186680/library_600x900.jpg"
  },
  {
    "value": "battlefield-v",
    "label": "Battlefield V",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1238810/library_600x900.jpg"
  },
  {
    "value": "r-e-p-o",
    "label": "R.E.P.O.",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/3241660/library_600x900.jpg"
  },
  {
    "value": "dayz",
    "label": "DayZ",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/221100/library_600x900.jpg"
  },
  {
    "value": "satisfactory",
    "label": "Satisfactory",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/526870/library_600x900.jpg"
  },
  {
    "value": "nba-2k20",
    "label": "NBA 2K20",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1089350/library_600x900.jpg"
  },
  {
    "value": "risk-of-rain-2",
    "label": "Risk of Rain 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/632360/library_600x900.jpg"
  },
  {
    "value": "ea-sports-fifa-23",
    "label": "EA SPORTS FIFA 23",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1811260/library_600x900.jpg"
  },
  {
    "value": "minecraft",
    "label": "Minecraft",
    "image": "https://upload.wikimedia.org/wikipedia/commons/3/37/Minecraft_Key-art.png"
  },
  {
    "value": "roblox",
    "label": "Roblox",
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Roblox_Logo_2022.svg/600px-Roblox_Logo_2022.svg.png"
  },
  {
    "value": "fortnite",
    "label": "Fortnite",
    "image": "https://upload.wikimedia.org/wikipedia/commons/0/0e/FortniteLogo.svg"
  },
  {
    "value": "league-of-legends",
    "label": "League of Legends",
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/League_of_Legends_2019_vector.svg/600px-League_of_Legends_2019_vector.svg.png"
  },
  {
    "value": "valorant",
    "label": "VALORANT",
    "image": "https://upload.wikimedia.org/wikipedia/en/b/ba/Valorant_cover.jpg"
  },
  {
    "value": "overwatch-2",
    "label": "Overwatch 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2357570/library_600x900.jpg"
  },
  {
    "value": "dota-2",
    "label": "Dota 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/570/library_600x900.jpg"
  },
  {
    "value": "genshin-impact",
    "label": "Genshin Impact",
    "image": "https://upload.wikimedia.org/wikipedia/en/5/5d/Genshin_Impact_logo.svg"
  },
  {
    "value": "world-of-warcraft",
    "label": "World of Warcraft",
    "image": "https://upload.wikimedia.org/wikipedia/en/6/65/World_of_Warcraft.png"
  },
  {
    "value": "diablo-iv",
    "label": "Diablo IV",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2344520/library_600x900.jpg"
  },
  {
    "value": "marvel-rivals",
    "label": "Marvel Rivals",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2767030/library_600x900.jpg"
  },
  {
    "value": "call-of-duty-warzone",
    "label": "Call of Duty: Warzone",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1962663/library_600x900.jpg"
  },
  {
    "value": "escape-from-tarkov",
    "label": "Escape from Tarkov",
    "image": "https://upload.wikimedia.org/wikipedia/en/2/20/Escape_from_Tarkov.jpg"
  },
  {
    "value": "forza-horizon-5",
    "label": "Forza Horizon 5",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1551360/library_600x900.jpg"
  },
  {
    "value": "final-fantasy-xiv",
    "label": "Final Fantasy XIV",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/39210/library_600x900.jpg"
  },
  {
    "value": "sea-of-thieves",
    "label": "Sea of Thieves",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1172620/library_600x900.jpg"
  },
  {
    "value": "starfield",
    "label": "Starfield",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1716740/library_600x900.jpg"
  },
  {
    "value": "god-of-war-ragnarok",
    "label": "God of War Ragnarök",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2322010/library_600x900.jpg"
  },
  {
    "value": "assassins-creed-shadows",
    "label": "Assassin's Creed Shadows",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/3159330/library_600x900.jpg"
  },
  {
    "value": "honkai-star-rail",
    "label": "Honkai: Star Rail",
    "image": "https://upload.wikimedia.org/wikipedia/en/7/7f/Honkai_Star_Rail_%28logo%29.png"
  },
  {
    "value": "fc-26",
    "label": "EA Sports FC 26",
    "image": "https://upload.wikimedia.org/wikipedia/en/f/f2/EA_FC_26_Cover.jpg"
  },
  {
    "value": "arc-raiders",
    "label": "ARC Raiders",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1808500/library_600x900.jpg"
  },
  {
    "value": "delta-force",
    "label": "Delta Force",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2507950/library_600x900.jpg"
  },
  {
    "value": "battlefield-6",
    "label": "Battlefield 6",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2807960/library_600x900.jpg"
  },
  {
    "value": "call-of-duty-black-ops-6",
    "label": "Call of Duty: Black Ops 6",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2933620/library_600x900.jpg"
  },
  {
    "value": "the-finals",
    "label": "The Finals",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2073850/library_600x900.jpg"
  },
  {
    "value": "kingdom-come-deliverance-2",
    "label": "Kingdom Come: Deliverance II",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1771300/library_600x900.jpg"
  },
  {
    "value": "clair-obscur-expedition-33",
    "label": "Clair Obscur: Expedition 33",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1903340/library_600x900.jpg"
  },
  {
    "value": "split-fiction",
    "label": "Split Fiction",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2001120/library_600x900.jpg"
  },
  {
    "value": "elden-ring-nightreign",
    "label": "Elden Ring Nightreign",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2622380/library_600x900.jpg"
  },
  {
    "value": "stalker-2",
    "label": "S.T.A.L.K.E.R. 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1643320/library_600x900.jpg"
  },
  {
    "value": "dune-awakening",
    "label": "Dune: Awakening",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1172710/library_600x900.jpg"
  },
  {
    "value": "wuthering-waves",
    "label": "Wuthering Waves",
    "image": "https://upload.wikimedia.org/wikipedia/commons/5/5d/Wuthering_Waves_logo.svg"
  },
  {
    "value": "throne-and-liberty",
    "label": "Throne and Liberty",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2429640/library_600x900.jpg"
  },
  {
    "value": "once-human",
    "label": "Once Human",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2139460/library_600x900.jpg"
  },
  {
    "value": "sid-meier-s-civilization-vii",
    "label": "Sid Meier's Civilization VII",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1295660/library_600x900.jpg"
  },
  {
    "value": "avowed",
    "label": "Avowed",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2457220/library_600x900.jpg"
  },
  {
    "value": "borderlands-4",
    "label": "Borderlands 4",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/1285190/library_600x900.jpg"
  },
  {
    "value": "marvels-spider-man-2",
    "label": "Marvel's Spider-Man 2",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2651280/library_600x900.jpg"
  },
  {
    "value": "peak",
    "label": "PEAK",
    "image": "https://upload.wikimedia.org/wikipedia/en/0/0f/PEAK_cover_image.jpg"
  },
  {
    "value": "inzoi",
    "label": "inZOI",
    "image": "https://cdn.cloudflare.steamstatic.com/steam/apps/2456740/library_600x900.jpg"
  },
  {
    "value": "resident-evil-requiem",
    "label": "Resident Evil Requiem",
    "image": "https://upload.wikimedia.org/wikipedia/en/1/15/Resident_Evil_Requiem_Cover_Art.jpg"
  }
];

// value → display label for every app and game (used for explanatory copy).
export const APP_GAME_LABELS: Record<string, string> = {
  "netflix": "Netflix",
  "youtube": "YouTube",
  "instagram": "Instagram",
  "facebook": "Facebook",
  "x-twitter": "X (Twitter)",
  "tiktok": "TikTok",
  "reddit": "Reddit",
  "twitch": "Twitch",
  "linkedin": "LinkedIn",
  "pinterest": "Pinterest",
  "canva": "Canva",
  "google-drive": "Google Drive",
  "google-meet": "Google Meet",
  "spotify-web": "Spotify Web",
  "notion-web": "Notion Web",
  "slack": "Slack",
  "microsoft-teams": "Microsoft Teams",
  "zoom": "Zoom",
  "discord": "Discord",
  "gmail": "Gmail",
  "outlook": "Outlook",
  "whatsapp-desktop": "WhatsApp Desktop",
  "telegram-desktop": "Telegram Desktop",
  "signal-desktop": "Signal Desktop",
  "skype": "Skype",
  "adobe-photoshop": "Adobe Photoshop",
  "adobe-illustrator": "Adobe Illustrator",
  "adobe-premiere-pro": "Adobe Premiere Pro",
  "adobe-after-effects": "Adobe After Effects",
  "adobe-lightroom": "Adobe Lightroom",
  "adobe-xd": "Adobe XD",
  "adobe-acrobat": "Adobe Acrobat",
  "davinci-resolve": "DaVinci Resolve",
  "blender": "Blender",
  "autocad": "AutoCAD",
  "fusion-360": "Fusion 360",
  "figma": "Figma",
  "obs-studio": "OBS Studio",
  "gimp": "GIMP",
  "inkscape": "Inkscape",
  "cinema-4d": "Cinema 4D",
  "capcut": "CapCut",
  "kdenlive": "Kdenlive",
  "handbrake": "HandBrake",
  "microsoft-word": "Microsoft Word",
  "microsoft-excel": "Microsoft Excel",
  "microsoft-powerpoint": "Microsoft PowerPoint",
  "power-bi-desktop": "Power BI Desktop",
  "libreoffice": "LibreOffice",
  "tableau-desktop": "Tableau Desktop",
  "obsidian": "Obsidian",
  "notion-desktop": "Notion Desktop",
  "google-workspace": "Google Workspace",
  "airtable": "Airtable",
  "onenote": "OneNote",
  "evernote": "Evernote",
  "spotify-desktop": "Spotify Desktop",
  "vlc-media-player": "VLC Media Player",
  "kodi": "Kodi",
  "plex": "Plex",
  "audacity": "Audacity",
  "apple-music": "Apple Music",
  "tidal": "Tidal",
  "mpc-hc": "MPC-HC",
  "winamp": "Winamp",
  "visual-studio-code": "Visual Studio Code",
  "intellij-idea": "IntelliJ IDEA",
  "pycharm": "PyCharm",
  "webstorm": "WebStorm",
  "clion": "CLion",
  "android-studio": "Android Studio",
  "visual-studio-2022": "Visual Studio 2022",
  "github-desktop": "GitHub Desktop",
  "docker-desktop": "Docker Desktop",
  "postman": "Postman",
  "sublime-text": "Sublime Text",
  "cursor": "Cursor",
  "google-chrome": "Google Chrome",
  "mozilla-firefox": "Mozilla Firefox",
  "microsoft-edge": "Microsoft Edge",
  "virtualbox": "VirtualBox",
  "vmware-workstation": "VMware Workstation",
  "1password": "1Password",
  "bitwarden": "Bitwarden",
  "dropbox": "Dropbox",
  "onedrive": "OneDrive",
  "filezilla": "FileZilla",
  "7-zip": "7-Zip",
  "sharex": "ShareX",
  "zoom-video": "Zoom (Video)",
  "chatgpt": "ChatGPT",
  "claude": "Claude",
  "google-gemini": "Google Gemini",
  "microsoft-copilot": "Microsoft Copilot",
  "perplexity": "Perplexity",
  "grammarly": "Grammarly",
  "trello": "Trello",
  "asana": "Asana",
  "jira": "Jira",
  "monday": "Monday.com",
  "clickup": "ClickUp",
  "miro": "Miro",
  "confluence": "Confluence",
  "cisco-webex": "Cisco Webex",
  "loom": "Loom",
  "salesforce": "Salesforce",
  "hubspot": "HubSpot",
  "quickbooks": "QuickBooks",
  "google-docs": "Google Docs",
  "google-sheets": "Google Sheets",
  "google-calendar": "Google Calendar",
  "quizlet": "Quizlet",
  "anki": "Anki",
  "zotero": "Zotero",
  "overleaf": "Overleaf",
  "solidworks": "SolidWorks",
  "ansys-workbench": "ANSYS Workbench",
  "matlab-simulink": "MATLAB/Simulink",
  "autodesk-fusion-360": "Autodesk Fusion 360",
  "abaqus": "Abaqus",
  "excel-python": "Excel / Python (data analysis)",
  "autodesk-revit": "Autodesk Revit",
  "autodesk-inventor": "Autodesk Inventor",
  "comsol-multiphysics": "COMSOL Multiphysics",
  "catia": "CATIA",
  "rhino-3d": "Rhino 3D",
  "sketchup": "SketchUp",
  "ibm-spss-statistics": "IBM SPSS Statistics",
  "microsoft-365": "Microsoft 365 (Office)",
  "siemens-nx": "Siemens NX",
  "ptc-creo": "PTC Creo",
  "openfoam": "OpenFOAM",
  "aspen-plus": "Aspen Plus",
  "aspen-hysys": "Aspen HYSYS",
  "gproms": "gPROMS",
  "labview": "LabVIEW",
  "ni-multisim": "NI Multisim",
  "orcad-pspice": "OrCAD PSpice",
  "altium-designer": "Altium Designer",
  "cadence-virtuoso": "Cadence Virtuoso",
  "kicad": "KiCad",
  "ltspice": "LTspice",
  "autocad-civil-3d": "AutoCAD Civil 3D",
  "tekla-structures": "Tekla Structures",
  "sap2000-etabs": "SAP2000 / ETABS",
  "autodesk-robot-lusas": "Autodesk Robot / LUSAS",
  "plaxis": "PLAXIS",
  "archicad": "ArchiCAD",
  "enscape": "Enscape",
  "lumion": "Lumion",
  "twinmotion": "Twinmotion",
  "v-ray": "V-Ray",
  "3ds-max": "Autodesk 3ds Max",
  "keyshot": "KeyShot",
  "autodesk-alias": "Autodesk Alias",
  "adobe-indesign": "Adobe InDesign",
  "adobe-audition": "Adobe Audition",
  "avid-media-composer": "Avid Media Composer",
  "final-cut-pro": "Final Cut Pro",
  "adobe-creative-cloud": "Adobe Creative Cloud (imaging apps)",
  "procreate": "Procreate",
  "clo3d": "CLO3D",
  "touchdesigner": "TouchDesigner",
  "logic-pro": "Logic Pro",
  "pro-tools": "Pro Tools",
  "ableton-live": "Ableton Live",
  "sibelius-dorico": "Sibelius / Dorico",
  "cubase-reaper": "Cubase / Reaper",
  "max-msp": "Max/MSP",
  "kontakt": "Kontakt",
  "arcgis-pro": "ArcGIS Pro",
  "qgis": "QGIS",
  "envi-erdas": "ENVI / ERDAS Imagine",
  "agisoft-metashape": "Agisoft Metashape",
  "petrel": "Petrel (SLB)",
  "leapfrog": "Leapfrog (Seequent)",
  "surfer-grapher": "Surfer / Grapher (Golden Software)",
  "google-earth-engine": "Google Earth Engine",
  "simapro": "SimaPro",
  "chemdraw": "ChemDraw",
  "gaussian-gaussview": "Gaussian / GaussView",
  "avogadro-spartan": "Avogadro / Spartan",
  "orca": "ORCA",
  "vmd": "VMD",
  "mercury-ccdc": "Mercury (CCDC)",
  "mestrenova": "MestReNova",
  "graphpad-prism": "GraphPad Prism",
  "imagej-fiji": "ImageJ / Fiji",
  "snapgene": "SnapGene",
  "geneious": "Geneious Prime",
  "3d-slicer": "3D Slicer",
  "r-rstudio": "R / RStudio",
  "stata": "Stata",
  "jasp": "JASP",
  "eviews": "EViews",
  "minitab": "Minitab",
  "mathematica": "Wolfram Mathematica",
  "maple": "Maple",
  "nvivo": "NVivo",
  "atlas-ti": "ATLAS.ti",
  "qualtrics": "Qualtrics",
  "sas": "SAS",
  "python": "Python",
  "java-jdk": "Java (JDK)",
  "c-cpp-toolchain": "C / C++ toolchain (GCC/Clang/MSVC)",
  "git": "Git",
  "linux-wsl": "Linux / WSL environment",
  "nodejs-web": "Node.js / JavaScript / React",
  "sql-databases": "SQL databases (MySQL/PostgreSQL)",
  "pytorch-tensorflow": "PyTorch / TensorFlow (deep learning)",
  "hadoop-spark": "Hadoop / Spark (big data)",
  "unity": "Unity",
  "unreal-engine": "Unreal Engine 5",
  "fpga-vivado": "Xilinx Vivado / FPGA tools",
  "jupyter-anaconda": "Jupyter / Anaconda (Python data science)",
  "complete-anatomy": "Complete Anatomy",
  "psychopy": "PsychoPy",
  "e-prime": "E-Prime",
  "kinovea": "Kinovea",
  "dartfish": "Dartfish",
  "quintic": "Quintic",
  "vicon-nexus": "Vicon Nexus",
  "medicinescomplete-bnf": "MedicinesComplete / BNF",
  "passmedicine-quesmed": "PassMedicine / Quesmed",
  "bloomberg-terminal": "Bloomberg Terminal",
  "refinitiv-eikon": "Refinitiv Eikon (LSEG)",
  "sage": "Sage Accounting",
  "sap-erp": "SAP (ERP / SAP GUI)",
  "legal-databases": "Westlaw / LexisNexis / Practical Law (legal databases)",
  "capital-iq": "S&P Capital IQ",
  "google-analytics": "Google Analytics",
  "praat": "Praat",
  "antconc": "AntConc",
  "elan": "ELAN",
  "sdl-trados": "SDL Trados Studio",
  "counter-strike-2": "Counter-Strike 2",
  "apex-legends": "Apex Legends",
  "pubg-battlegrounds": "PUBG: BATTLEGROUNDS",
  "palworld": "Palworld",
  "team-fortress-2": "Team Fortress 2",
  "call-of-duty-modern-warfare-ii": "Call of Duty: Modern Warfare II",
  "new-world-aeternum": "New World: Aeternum",
  "black-myth-wukong": "Black Myth: Wukong",
  "grand-theft-auto-v": "Grand Theft Auto V",
  "left-4-dead-2": "Left 4 Dead 2",
  "unturned": "Unturned",
  "lost-ark": "Lost Ark",
  "war-thunder": "War Thunder",
  "monster-hunter-wilds": "Monster Hunter Wilds",
  "helldivers-2": "HELLDIVERS 2",
  "warframe": "Warframe",
  "elden-ring": "ELDEN RING",
  "terraria": "Terraria",
  "path-of-exile-2": "Path of Exile 2",
  "wallpaper-engine": "Wallpaper Engine",
  "baldur-s-gate-3": "Baldur's Gate 3",
  "brawlhalla": "Brawlhalla",
  "garry-s-mod": "Garry's Mod",
  "destiny-2": "Destiny 2",
  "tom-clancy-s-rainbow-six-siege": "Tom Clancy's Rainbow Six Siege",
  "rust": "Rust",
  "world-of-warships": "World of Warships",
  "ark-survival-evolved": "ARK: Survival Evolved",
  "stardew-valley": "Stardew Valley",
  "the-forest": "The Forest",
  "war-robots-frontiers": "War Robots: Frontiers",
  "path-of-exile": "Path of Exile",
  "payday-2": "PAYDAY 2",
  "warface-clutch": "Warface: Clutch",
  "grand-theft-auto-iv-complete-edition": "Grand Theft Auto IV: Complete Edition",
  "last-epoch": "Last Epoch",
  "half-life-2-lost-coast": "Half-Life 2: Lost Coast",
  "cyberpunk-2077": "Cyberpunk 2077",
  "dead-by-daylight": "Dead by Daylight",
  "hogwarts-legacy": "Hogwarts Legacy",
  "vrchat": "VRChat",
  "the-witcher-3-wild-hunt": "The Witcher 3: Wild Hunt",
  "among-us": "Among Us",
  "fall-guys": "Fall Guys",
  "borderlands-2": "Borderlands 2",
  "euro-truck-simulator-2": "Euro Truck Simulator 2",
  "valheim": "Valheim",
  "phasmophobia": "Phasmophobia",
  "paladins": "Paladins",
  "naraka-bladepoint": "NARAKA: BLADEPOINT",
  "half-life-2-deathmatch": "Half-Life 2: Deathmatch",
  "half-life": "Half-Life",
  "monster-hunter-world": "Monster Hunter: World",
  "heroes-generals": "Heroes & Generals",
  "rocket-league": "Rocket League",
  "project-zomboid": "Project Zomboid",
  "lethal-company": "Lethal Company",
  "red-dead-redemption-2": "Red Dead Redemption 2",
  "battlefield-2042": "Battlefield 2042",
  "halo-infinite": "Halo Infinite",
  "raft": "Raft",
  "smite": "SMITE",
  "world-of-tanks-blitz": "World of Tanks Blitz",
  "counter-strike": "Counter-Strike",
  "counter-strike-source": "Counter-Strike: Source",
  "schedule-i": "Schedule I",
  "ring-of-elysium": "Ring of Elysium",
  "portal": "Portal",
  "the-sims-4": "The Sims 4",
  "black-squad": "Black Squad",
  "don-t-starve-together": "Don't Starve Together",
  "dying-light": "Dying Light",
  "human-fall-flat": "Human Fall Flat",
  "7-days-to-die": "7 Days to Die",
  "counter-strike-condition-zero": "Counter-Strike: Condition Zero",
  "efootball-2025": "eFootball 2025",
  "street-warriors-online": "Street Warriors Online",
  "z1-battle-royale": "Z1 Battle Royale",
  "hunt-showdown-1896": "Hunt: Showdown 1896",
  "sekiro-shadows-die-twice-goty-edition": "Sekiro: Shadows Die Twice - GOTY Edition",
  "cybercorp": "CyberCorp",
  "half-life-2": "Half-Life 2",
  "arma-3": "Arma 3",
  "sons-of-the-forest": "Sons Of The Forest",
  "grim-dawn": "Grim Dawn",
  "cities-skylines": "Cities: Skylines",
  "mount-blade-ii-bannerlord": "Mount & Blade II: Bannerlord",
  "sid-meier-s-civilization-v": "Sid Meier's Civilization V",
  "trove": "Trove",
  "sid-meier-s-civilization-vi": "Sid Meier's Civilization VI",
  "fallout-4": "Fallout 4",
  "life-is-strange-2": "Life is Strange 2",
  "warhammer-40-000-rogue-trader": "Warhammer 40,000: Rogue Trader",
  "battlefield-v": "Battlefield V",
  "r-e-p-o": "R.E.P.O.",
  "dayz": "DayZ",
  "satisfactory": "Satisfactory",
  "nba-2k20": "NBA 2K20",
  "risk-of-rain-2": "Risk of Rain 2",
  "ea-sports-fifa-23": "EA SPORTS FIFA 23",
  "minecraft": "Minecraft",
  "roblox": "Roblox",
  "fortnite": "Fortnite",
  "league-of-legends": "League of Legends",
  "valorant": "VALORANT",
  "overwatch-2": "Overwatch 2",
  "dota-2": "Dota 2",
  "genshin-impact": "Genshin Impact",
  "world-of-warcraft": "World of Warcraft",
  "diablo-iv": "Diablo IV",
  "marvel-rivals": "Marvel Rivals",
  "call-of-duty-warzone": "Call of Duty: Warzone",
  "escape-from-tarkov": "Escape from Tarkov",
  "forza-horizon-5": "Forza Horizon 5",
  "final-fantasy-xiv": "Final Fantasy XIV",
  "sea-of-thieves": "Sea of Thieves",
  "starfield": "Starfield",
  "god-of-war-ragnarok": "God of War Ragnarök",
  "assassins-creed-shadows": "Assassin's Creed Shadows",
  "honkai-star-rail": "Honkai: Star Rail",
  "fc-26": "EA Sports FC 26",
  "arc-raiders": "ARC Raiders",
  "delta-force": "Delta Force",
  "battlefield-6": "Battlefield 6",
  "call-of-duty-black-ops-6": "Call of Duty: Black Ops 6",
  "the-finals": "The Finals",
  "kingdom-come-deliverance-2": "Kingdom Come: Deliverance II",
  "clair-obscur-expedition-33": "Clair Obscur: Expedition 33",
  "split-fiction": "Split Fiction",
  "elden-ring-nightreign": "Elden Ring Nightreign",
  "stalker-2": "S.T.A.L.K.E.R. 2",
  "dune-awakening": "Dune: Awakening",
  "wuthering-waves": "Wuthering Waves",
  "throne-and-liberty": "Throne and Liberty",
  "once-human": "Once Human",
  "sid-meier-s-civilization-vii": "Sid Meier's Civilization VII",
  "avowed": "Avowed",
  "borderlands-4": "Borderlands 4",
  "marvels-spider-man-2": "Marvel's Spider-Man 2",
  "peak": "PEAK",
  "inzoi": "inZOI",
  "resident-evil-requiem": "Resident Evil Requiem"
};
